import { Link } from "react-router-dom";
import { videos } from "@/mocks/videos";
import type { Video } from "@/mocks/types";

function VideoCard({ video }: { video: Video }) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300/60 transition-all duration-300"
    >
      <div className="relative w-full aspect-video overflow-hidden">
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 红桃视频在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300"></div>
        <div className="absolute bottom-2 right-2 bg-black/70 backdrop-blur-sm text-white text-xs px-2 py-0.5 rounded-md">
          {video.duration}
        </div>
        <div className="absolute top-2 left-2">
          <span className="bg-primary-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">
            {video.rating}
          </span>
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-14 h-14 flex items-center justify-center bg-primary-500/90 rounded-full">
            <i className="ri-play-fill text-white text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <div className="p-4">
        <h3 className="text-sm font-semibold text-foreground-950 line-clamp-1 mb-1.5 group-hover:text-primary-500 transition-colors">
          {video.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
          {video.description}
        </p>
        <div className="flex items-center justify-between mt-3">
          <span className="text-xs text-foreground-400">
            {(video.views / 10000).toFixed(0)}万次播放
          </span>
          <div className="flex items-center gap-1">
            {video.tags.slice(0, 2).map((tag) => (
              <span key={tag} className="text-xs text-secondary-600 bg-secondary-100/70 px-2 py-0.5 rounded-full">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
}

export default function FeaturedVideos() {
  const featured = videos.filter((v) => v.featured).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">为您精心挑选的高品质视频内容</p>
          </div>
          <Link
            to="/category/movie"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-product-shop="">
          {featured.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}